// Plan v3 copy (R-73): drafted by Astra (copy lane, build/astra/copy-planv3-prompt.md -> copy-planv3.txt; round 2 after the
// first blind test: copy-planv3-r2-prompt.md -> copy-planv3-r2.txt; round 3: copy-planv3-r3*; round 4: copy-planv3-r4*, r4b, r4c, r4d; round 5: copy-planv3-r5; round 6: copy-planv3-r6), gated by Claude 10/08/26
// (all keys present, placeholders kept, no dashes / exclamation marks / AI words / "listings" / brackets). Do not edit by hand:
// a line that needs to change goes back to Astra. Kept in its own file so the sign-in branch's copyFlow2.ts edits merge cleanly.
import { f2, hasF2 } from './copyFlow2'

export const V3: Record<string, string> = {
  "v3.nav_saved": "Saved",
  "v3.nav_saved_count": "Saved · {count}",
  "v3.nav_itineraries": "Itineraries",
  "v3.save": "Save",
  "v3.saved": "Saved",
  "v3.saving": "Saving",
  "v3.unsave_label": "Remove {title} from Saved",
  "v3.save_error": "Couldn't save this. Try again.",
  "v3.toast_one": "{count} thing saved",
  "v3.toast_other": "{count} things saved",
  "v3.toast_see": "See Saved",
  "v3.saved_title": "Saved",
  "v3.saved_sub": "Everything you saved, grouped by area. Build a day out when you're ready.",
  "v3.saved_group_near": "Near {area}",
  "v3.saved_group_other": "Other places",
  "v3.search_button": "Search",
  "v3.search_row": "Search for “{text}”",
  "v3.search_looking": "Looking up “{place}”",
  "v3.search_building_title": "Finding things to do in {city}",
  "v3.search_building_body": "This takes about a minute the first time. You can keep this page open and see things appear as we find them.",
  "v3.search_building_found": "Found so far: {count}",
  "v3.search_not_found": "We couldn’t find “{text}”. Try a city, neighborhood or zip code. We’re showing what’s around {home} instead.",
  "v3.search_need_city": "Pick a city in “{place}”.",
  "v3.build": "Build an itinerary",
  "v3.build_from": "Build around this",
  "v3.saved_more": "Show {count} more",
  "v3.saved_less": "Show less",
  "v3.saved_error": "Couldn't load your saved things. Try again.",
  "v3.empty_title": "Nothing saved yet",
  "v3.empty_body": "Save things you'd like to do as you browse. Then build a day around them.",
  "v3.empty_browse": "Browse",
  "v3.build_title": "Build an itinerary",
  "v3.build_sub": "One day, built from things you saved. Start with a day or an activity.",
  "v3.door_day_title": "Pick a day",
  "v3.door_day_body": "We'll fill it with saved things that fit that day.",
  "v3.door_activity_title": "Start with an activity",
  "v3.door_activity_body": "Pick something you saved. We'll build the day around it.",
  "v3.pick_activity_title": "Which activity comes first?",
  "v3.step": "Step {n} of {total}",
  "v3.next": "Next",
  "v3.where_title": "Where are you headed?",
  "v3.where_sub": "We'll only use saved things in this area.",
  "v3.home_place": "Home · {place}",
  "v3.city_place": "{city} · City center",
  "v3.within": "Within",
  "v3.miles": "{miles} mi",
  "v3.cities_label": "Cities with saved things",
  "v3.area_count_one": "{count} saved thing in this area",
  "v3.area_count": "{count} saved things in this area",
  "v3.area_hidden": "Saved farther out · {count}",
  "v3.other_city_title": "Nothing saved in {city} yet",
  "v3.other_city_body": "Saved in {city} · {count}",
  "v3.switch_city": "Switch to {city}",
  "v3.browse_city": "Browse {city}",
  "v3.day_title": "Pick a day",
  "v3.day_sub": "Each dot is one saved thing that fits that day.",
  "v3.week_range": "{range}",
  "v3.fit_one": "1 saved thing fits",
  "v3.fit_other": "{count} saved things fit",
  "v3.fit_none": "Nothing saved fits",
  "v3.further_out": "Choose a later date",
  "v3.fill_day": "Fill {day}",
  "v3.earlier_days": "Show earlier days",
  "v3.later_days": "Show later days",
  "v3.any_day": "Any day",
  "v3.month_fit_one": "{date} · {count} saved thing fits",
  "v3.month_fit_other": "{date} · {count} saved things fit",
  "v3.month_fit_none": "{date} · {count} saved things fit",
  "v3.pick_this_day": "Pick this day",
  "v3.prev_month": "Previous month",
  "v3.next_month": "Next month",
  "v3.filling": "Building your day",
  "v3.filled_from": "Built from your saved things in {city}",
  "v3.also_fits": "Also fits this day",
  "v3.add": "Add",
  "v3.make_itinerary": "Confirm itinerary",
  "v3.left_out": "{title} was left out. {reason}",
  "v3.build_error": "Couldn't build this day. Try again.",
  "v3.none_fit_title": "Nothing you saved fits this day",
  "v3.days_that_fit": "Days your saved things fit",
  "v3.pick_another": "Pick another day",
  "v3.browse_day": "Browse {day} activities",
  "v3.around_title": "Build around this",
  "v3.starting_point": "Your starting point",
  "v3.its_day": "On {date}",
  "v3.nearby_fit": "Saved things nearby that fit around it",
  "v3.min_away": "{minutes} min away",
  "v3.time_later": "Time chosen when built",
  "v3.around_none": "Nothing else you saved nearby fits around this activity that day.",
  "v3.any_day_first": "This activity fits any day. Pick a day to build around it.",
  "v3.build_my_day": "Build my day",
  "v3.itin_sub_one": "{city} · {count} activity",
  "v3.itin_sub_other": "{city} · {count} activities",
  "v3.add_all_google": "Google Calendar · Add all",
  "v3.add_all_apple": "Apple Calendar · Add all",
  "v3.add_google": "Add to Google Calendar",
  "v3.add_apple": "Apple Calendar",
  "v3.added_google": "Added to Google Calendar",
  "v3.added_apple": "Sent to Apple Calendar",
  "v3.add_next_google": "Add next · {count} left",
  "v3.all_added": "Everything is on your calendar",
  "v3.no_time": "This activity needs a time before it can go on your calendar.",
  "v3.calendar_note": "Changes here won't update what's already on your calendar.",
  "v3.itins_title": "Itineraries",
  "v3.itins_sub": "Every day you've built, all here.",
  "v3.itins_empty_title": "No itineraries yet",
  "v3.itins_empty_body": "Start with things you saved and build a day out.",
  "v3.itins_count_one": "{count} activity",
  "v3.itins_count_other": "{count} activities",
  "v3.itins_past": "Past",
  "v3.set_dates": "Certain dates only · Check the source for dates",
  "v3.suggestion": "Suggested",
  "v3.suggestions_title": "More nearby for your day",
  "v3.suggestions_note": "From your For you picks to round out the day. Remove any you don't want.",
  "v3.plan_around": "Build around this",
  "v3.more_dates": "More dates · {count}",
  "v3.build_slow": "This is taking longer than usual. Try again.",
  "v3.consent": "By saving, you confirm you're 18 or older, agree to the Terms, and acknowledge the Privacy page.",
  "v3.cal_add": "Add to {calendar}",
  "v3.cal_opening": "Opening calendar…",
  "v3.cal_again": "Add again",
  "v3.cal_use_other": "Use {calendar} instead",
  "v3.add_all_to": "Add all · {calendar}",
  "v3.add_all_again": "Add all again",
  "v3.browse_sub": "Explore Los Angeles, follow an interest, and put an itinerary together.",
  "v3.browse_sub_city": "Explore {city}, follow an interest, and put an itinerary together.",
  "v3.suggest_add_note": "Nearby picks based on what you like. Add any that appeal.",
  "v3.suggest_on_day_note": "We've filled out your day with a few suggestions. Remove any you don't want.",
  "v3.cal_added": "Added to calendar",
  "v3.send_again": "Send again",
  "v3.photo_credit": "Photo: {credit}",
  "v3.added_to_day": "Added to your day",
  "v3.cal_sent_one": "{count} event sent to {calendar}.",
  "v3.cal_sent_other": "{count} events sent to {calendar}.",
  "v3.cal_choose_title": "Which calendar do you use?",
  "v3.cal_change": "Change calendar",
  "v3.clash": "Not enough time to drive here from the previous stop.",
  // B-089 (Astra, 10/13; same words as the server's TOO_LATE_TODAY in plan/placing.ts)
  "v3.too_late_today": "You wouldn't get there before closing today. Another day may work.",
  "v3.cant_fit": "{title} couldn't fit into this day.",
  "v3.area_change": "Change area",
  "v3.nearby_tag": "Nearby",
  "v3.where_placeholder": "City, area or postal code",
  "v3.google_next": "Next: add {n} of {total} to Google Calendar",
  "v3.google_progress": "{n} of {total} sent to Google Calendar",
  "v3.ics_all": "Download all as one calendar file (.ics)",
  "v3.distance_tiny": "Under 0.1 mi",
  "v3.saved_building": "Saved, and building your day",
  "v3.add_more": "Add more to this day",
  "v3.only_this_one": "Nothing else fits this day, so your itinerary will have just this activity.",
}

/** A Plan v3 line ({name} filled in); other keys fall through to the app's approved Flow 2 strings. */
export function v3(key: string, vars?: Record<string, string | number>): string {
  const s = V3[key] ?? (hasF2(key) ? f2(key) : key)
  return vars ? s.replace(/\{(\w+)\}/g, (m, k: string) => (k in vars ? String(vars[k]) : m)) : s
}
